export default "__VITE_ASSET__34dfd5c6__"